@if (targets().length > 0) {
    <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
        @for (target of targets(); track $index) {
            <sh-referred-out-item
                [referredOutEmail]="target.referredOutEmail"
                [referredOutTeam]="target.referredOutTeam"
                [isInternalReferral]="target.isInternalReferredOut"
            ></sh-referred-out-item>
        }
    </div>
}
